"use strict";

let KDDefaultNames = [
	"default",
	"default",
	"default",
	"default",
	"nevermere",
	"bountyhunter",
	"japanese",
	"japanese",
	"japanese",
	"elf",
	"dragonheart",
	"maid",
	"russian",
	"elemental",
	"aztec",
	"witch",
	"cyborg",
	"bast",
	"DragonGirl",
];

let KDNameList = {
	default: [
		"Aiko",
		"Aina",
		"Alexa",
		"Alice",
		"Amber",
		"Ami",
		"Anna",
		"Aria",
		"Avery",
		"Ayumi",
		"Bailey",
		"Beth",
		"Bianca",
		"Blair",
		"Bonnie",
		"Brooke",
		"Cara",
		"Cassidy",
		"Chloe",
		"Chika",
		"Daisy",
		"Dana",
		"Daniela",
		"Darcy",
		"Dawn",
		"Delilah",
		"Diana",
		"Dylan",
		"Eden",
		"Elena",
		"Elise",
		"Ellie",
		"Emi",
		"Emily",
		"Emma",
		"Erin",
		"Eva",
		"Evelyn",
		"Faith",
		"Fiona",
		"Freya",
		"Fumiko",
		"Gemma",
		"Grace",
		"Hailey",
		"Hana",
		"Hannah",
		"Harper",
		"Hazel",
		"Heidi",
		"Iris",
		"Isabel",
		"Isabella",
		"Isla",
		"Ivy",
		"Jade",
		"Jamie",
		"Jasmine",
		"Jenna",
		"Jill",
		"Jodie",
		"Julia",
		"Kaede",
		"Kai",
		"Kana",
		"Karen",
		"Karina",
		"Kate",
		"Kayla",
		"Keira",
		"Kelly",
		"Kendra",
		"Kimiko",
		"Kira",
		"Kylie",
		"Lana",
		"Lara",
		"Laura",
		"Lauren",
		"Layla",
		"Leah",
		"Leila",
		"Lila",
		"Lily",
		"Lina",
		"Lola",
		"Lucy",
		"Luna",
		"Macy",
		"Maddie",
		"Maeve",
		"Mai",
		"Makayla",
		"Maki",
		"Malia",
		"Mandy",
		"Maria",
		"Marie",
		"Maya",
		"Mayu",
		"Megan",
		"Melanie",
		"Mia",
		"Mika",
		"Mila",
		"Mina",
		"Mira",
		"Misaki",
		"Molly",
		"Naomi",
		"Natalie",
		"Natasha",
		"Nia",
		"Nicole",
		"Nina",
		"Noa",
		"Noelle",
		"Nora",
		"Noriko",
		"Olivia",
		"Paige",
		"Parker",
		"Peyton",
		"Piper",
		"Quinn",
		"Rachel",
		"Reagan",
		"Reese",
		"Rei",
		"Reina",
		"Renee",
		"Riley",
		"Rina",
		"Risa",
		"Ruby",
		"Rumi",
		"Sabrina",
		"Sage",
		"Sakura",
		"Samantha",
		"Sara",
		"Sasha",
		"Scarlett",
		"Selena",
		"Serena",
		"Shannon",
		"Sienna",
		"Skye",
		"Sofia",
		"Stella",
		"Summer",
		"Tara",
		"Tessa",
		"Tia",
		"Tina",
		"Tracy",
		"Valeria",
		"Vanessa",
		"Veronica",
		"Victoria",
		"Violet",
		"Wendy",
		"Willow",
		"Wren",
		"Xena",
		"Yoko",
		"Yui",
		"Yuka",
		"Yuki",
		"Yumi",
		"Zara",
		"Zoe",
		"Zoey"
	],
	nevermere: [
		"Aada",
		"Aila",
		"Aino",
		"Airi",
		"Alma",
		"Anja",
		"Anni",
		"Arja",
		"Asta",
		"Aune",
		"Birgit",
		"Bodil",
		"Brynja",
		"Brita",
		"Britt",
		"Camilla",
		"Cecilia",
		"Clara",
		"Corinna",
		"Christina",
		"Dagmar",
		"Dagny",
		"Dana",
		"Diana",
		"Dora",
		"Ebba",
		"Edda",
		"Eira",
		"Elin",
		"Elisa",
		"Embla",
		"Emma",
		"Enni",
		"Erika",
		"Erna",
		"Freya",
		"Frida",
		"Gerda",
		"Greta",
		"Gunhild",
		"Hanna",
		"Hanne",
		"Heidi",
		"Helga",
		"Helle",
		"Hilda",
		"Iida",
		"Iiris",
		"Ilona",
		"Inga",
		"Ingrid",
		"Irene",
		"Isa",
		"Janna",
		"Jenny",
		"Kaia",
		"Kaisa",
		"Kari",
		"Katja",
		"Kerttu",
		"Kiira",
		"Laila",
		"Laura",
		"Leena",
		"Liisa",
		"Lilja",
		"Linnea",
		"Lotta",
		"Lydia",
		"Maia",
		"Maija",
		"Maiju",
		"Malin",
		"Maren",
		"Maria",
		"Marja",
		"Matilda",
		"Meeri",
		"Mette",
		"Mia",
		"Milla",
		"Nanna",
		"Nella",
		"Nora",
		"Oda",
		"Olga",
		"Orla",
		"Otti",
		"Paula",
		"Petra",
		"Ragna",
		"Rakel",
		"Rebekka",
		"Riina",
		"Riitta",
		"Rita",
		"Ronja",
		"Runa",
		"Saana",
		"Saga",
		"Sanna",
		"Sara",
		"Selma",
		"Signe",
		"Sigrid",
		"Sini",
		"Sirpa",
		"Sofia",
		"Solveig",
		"Sonja",
		"Suvi",
		"Taina",
		"Tanja",
		"Tea",
		"Terhi",
		"Tiia",
		"Tiina",
		"Tuula",
		"Tyra",
		"Ulla",
		"Ulrika",
		"Una",
		"Vala",
		"Vanja",
		"Veera",
		"Vera",
		"Vivi",
		"Vilma",
		"Ylva",
		"Yrsa",
		"Zara",
		"Zoe",
		"Zora"
	],
	bountyhunter: [
		"Abigail",
		"Ada",
		"Adriana",
		"Aileen",
		"Alice",
		"Alina",
		"Alison",
		"Amelia",
		"Anastasia",
		"Angelina",
		"Barbara",
		"Belle",
		"Beth",
		"Bianca",
		"Blair",
		"Bonnie",
		"Bridget",
		"Brooke",
		"Cara",
		"Cecily",
		"Charlotte",
		"Chloe",
		"Christina",
		"Claire",
		"Clara",
		"Cora",
		"Cynthia",
		"Daisy",
		"Dana",
		"Daria",
		"Delilah",
		"Diana",
		"Dora",
		"Dylan",
		"Edith",
		"Eira",
		"Elena",
		"Elise",
		"Elizabeth",
		"Ellie",
		"Emilia",
		"Emma",
		"Erica",
		"Eva",
		"Evelyn",
		"Faith",
		"Fiona",
		"Freya",
		"Gemma",
		"Grace",
		"Hanna",
		"Harriet",
		"Hazel",
		"Heidi",
		"Helena",
		"Holly",
		"Hope",
		"Iris",
		"Isabel",
		"Ivy",
		"Jade",
		"Jane",
		"Jasmine",
		"Jennifer",
		"Jessica",
		"Jill",
		"Jodie",
		"Julia",
		"Kaia",
		"Kara",
		"Kate",
		"Katya",
		"Keira",
		"Kelly",
		"Kim",
		"Kira",
		"Kristina",
		"Lana",
		"Lara",
		"Laura",
		"Leah",
		"Lena",
		"Lila",
		"Lily",
		"Lina",
		"Lola",
		"Lucy",
		"Luna",
		"Macy",
		"Maddie",
		"Maeve",
		"Mara",
		"Maria",
		"Marina",
		"Martha",
		"Mary",
		"Maya",
		"Megan",
		"Melanie",
		"Mia",
		"Mila",
		"Mina",
		"Mira",
		"Molly",
		"Nadia",
		"Nancy",
		"Naomi",
		"Natalia",
		"Natasha",
		"Nina",
		"Noor",
		"Nora",
		"Olga",
		"Olivia",
		"Paige",
		"Penny",
		"Piper",
		"Quinn",
		"Rachel",
		"Rebecca",
		"Renee",
		"Riley",
		"Rina",
		"Rita",
		"Ruby",
		"Ruth",
		"Sabrina",
		"Sage",
		"Samantha",
		"Sara",
		"Scarlett",
		"Selena",
		"Serena",
		"Shannon",
		"Sienna",
		"Sofia",
		"Sonya",
		"Stella",
		"Summer",
		"Tara",
		"Tessa",
		"Tina",
		"Tracy",
		"Valeria",
		"Vanessa",
		"Veronica",
		"Victoria",
		"Violet",
		"Vivian",
		"Wendy",
		"Willow",
		"Wren",
		"Xena",
		"Yana",
		"Yulia",
		"Zara",
		"Zoe",
		"Zoya"
	],
	japanese: [
		"Akane",
		"Akemi",
		"Akiko",
		"Akira",
		"Aoi",
		"Asami",
		"Asuka",
		"Ayaka",
		"Ayame",
		"Azumi",
		"Chiaki",
		"Chie",
		"Chiharu",
		"Chika",
		"Chinatsu",
		"Chiyoko",
		"Chizuru",
		"Emi",
		"Eri",
		"Etsuko",
		"Fumiko",
		"Fuyumi",
		"Haruka",
		"Haruko",
		"Harumi",
		"Hikari",
		"Hikaru",
		"Hinata",
		"Hitomi",
		"Honoka",
		"Izumi",
		"Junko",
		"Kaede",
		"Kagome",
		"Kana",
		"Kanako",
		"Kaori",
		"Kasumi",
		"Katsumi",
		"Kayo",
		"Keiko",
		"Kikyo",
		"Kimiko",
		"Kiyomi",
		"Koharu",
		"Kotone",
		"Kumiko",
		"Kureha",
		"Kurumi",
		"Kyoko",
		"Machi",
		"Mai",
		"Maki",
		"Mami",
		"Mao",
		"Mariko",
		"Masami",
		"Mayu",
		"Mei",
		"Michiko",
		"Mika",
		"Miki",
		"Miku",
		"Mina",
		"Mio",
		"Misaki",
		"Mitsuki",
		"Miyako",
		"Miyu",
		"Miyuki",
		"Moe",
		"Momoko",
		"Nagisa",
		"Nami",
		"Nana",
		"Nanami",
		"Nao",
		"Naoko",
		"Narumi",
		"Natsuki",
		"Natsumi",
		"Noriko",
		"Rei",
		"Reika",
		"Reiko",
		"Rena",
		"Rika",
		"Riko",
		"Rin",
		"Rina",
		"Rio",
		"Risa",
		"Ritsuko",
		"Rumi",
		"Runa",
		"Ruri",
		"Ryoko",
		"Sachi",
		"Sachiko",
		"Saki",
		"Sakura",
		"Satomi",
		"Sayaka",
		"Sayo",
		"Sayuri",
		"Setsuko",
		"Shiho",
		"Shinobu",
		"Shiori",
		"Shizuka",
		"Shizuko",
		"Sora",
		"Sumi",
		"Sumire",
		"Suzume",
		"Suzuna",
		"Tamaki",
		"Tamami",
		"Tami",
		"Tomoe",
		"Tomoko",
		"Tsukiko",
		"Tsukimi",
		"Ume",
		"Umeko",
		"Yoko",
		"Yoshiko",
		"Yui",
		"Yuka",
		"Yuki",
		"Yukiko",
		"Yuko",
		"Yumi",
		"Yuna",
		"Yuri",
		"Yuriko",
		"Yuuka",
		"Yuuki",
		"Yuzuki"
	],
	elf: [


		"Aerith", "Aira", "Alanna", "Alora", "Amara", "Anara", "Anwen", "Aria", "Ariana", "Arwen",
		"Bella", "Brielle", "Brynn", "Calia", "Cara", "Carys", "Celia", "Cora", "Cyra", "Dara",
		"Della", "Diana", "Dora", "Eira", "Elena", "Elia", "Elin", "Elora", "Elysia", "Ember",
		"Enna", "Eowyn", "Erin", "Eva", "Fae", "Fara", "Fay", "Faye", "Fiona", "Freya",
		"Gala", "Gwen", "Gwyn", "Hana", "Hazel", "Iara", "Ida", "Ila", "Iris", "Isa",
		"Isla", "Ivy", "Jade", "Jana", "Jara", "Jasmine", "Jenna", "Jessa", "Jora", "Julia",
		"Kaia", "Kara", "Kaya", "Kayla", "Keira", "Kira", "Kyra", "Lana", "Lara", "Layla",
		"Lea",  "Lena", "Lia", "Lila", "Lily", "Lina", "Lira", "Livia", "Lora",
		"Luna", "Lyra", "Mae", "Maia", "Mara", "Maya", "Mia", "Mila", "Mira", "Myra",
		"Nadia", "Nala", "Nara", "Naya", "Nia", "Nina", "Nora", "Nova", "Nyra", "Ora",
		"Orla", "Pia", "Rae", "Raina", "Rana", "Rayla", "Rea", "Ria", "Rina", "Risa",
		"Rona", "Rosa", "Ruby", "Runa", "Ryla", "Sage", "Sara", "Sela", "Shay", "Shira",
		"Sia", "Sira", "Skye", "Sora", "Stella", "Talia", "Tara", "Tessa", "Thea", "Thora",
		"Tia", "Tina", "Tyra", "Una", "Ura", "Vala", "Vana", "Vera", "Vina", "Willa",
		"Wren", "Xara", "Xena", "Yara", "Yna", "Yora", "Zara", "Zayla", "Zella", "Zia",
		"Zira", "Zoe", "Zora", "Zyla", "Zyra"
	],
	dragonheart: [
		"Aanya", "Astrid", "Athena", "Aria", "Anika", "Alia", "Ava", "Anya", "Asha", "Aurora",
		"Bianca", "Bryn", "Bhavna", "Bella", "Britt", "Bina", "Bria", "Bhumi", "Brielle", "Bria",
		"Chloe", "Chaya", "Cora", "Cleo", "Chandra", "Cara", "Cassia", "Calla", "Celia", "Clara",
		"Daisy", "Dahlia", "Daphne", "Diana", "Divya", "Dana", "Drishti", "Dora", "Dina", "Delia",
		"Ella", "Eva", "Elsa", "Elena", "Esha", "Erika", "Eira", "Eliana", "Eve", "Elise",
		"Freya", "Fiona", "Flora", "Faith", "Frida", "Faye", "Fia", "Fara", "Freyja", "Felicity",
		"Grace", "Gia", "Gaia", "Gwen", "Greta", "Gemma", "Gia", "Gauri", "Gloria", "Gianna",
		"Hazel", "Hera", "Hannah", "Harper", "Heidi", "Holly", "Hira", "Helena", "Hana", "Hope",
		"Iris", "Isla", "Ivy", "Isabel", "Ingrid", "Irene", "Isha", "Ida", "Iliana", "Iona",
		"Jade", "Jasmine", "Jaya", "Julia", "Juno", "Jenna", "Jia", "Jyoti", "Jessa", "Joy",
		"Kira", "Kara", "Kavya", "Kaya", "Kendra", "Kira", "Kiara", "Kali", "Kaia", "Kira",
		"Lila", "Luna", "Lily", "Lara", "Lila", "Lana", "Lia",  "Lina", "Lola",
		"Maya", "Mia", "Mila", "Mira", "Mina", "Mona", "Mara", "Maia", "Molly", "Macy",
		"Nora", "Nina", "Nia", "Navya", "Nadia", "Nora", "Nola", "Naya", "Nora", "Neva",
		"Olivia", "Olive", "Ophelia", "Opal", "Orla", "Oona", "Odessa", "Oriana", "Octavia", "Olympia",
		"Pia", "Phoebe", "Priya", "Piper", "Pari", "Paige", "Peyton", "Penelope", "Polly", "Poppy",
		"Quinn", "Quincy", "Quin", "Quiana", "Quira", "Quinta", "Quilla", "Quorra", "Quella", "Querida",
		"Ruby", "Riya", "Rhea", "Rosa", "Ria", "Renee", "Raya", "Rani", "Rina", "Riley",
		"Sara", "Sophia", "Sienna", "Stella", "Sana", "Sage", "Sofia", "Siri", "Sia", "Skyla",
		"Tara", "Tessa", "Thea", "Tia", "Trisha", "Tara", "Thora", "Tara", "Tina", "Talia",
		"Uma", "Ursa", "Una", "Uma", "Uma", "Uma", "Uma", "Uma", "Uma", "Uma",
		"Vera", "Veda", "Violet", "Veda", "Veda", "Veda", "Veda", "Veda", "Veda", "Veda",
		"Willa", "Wren", "Willa",
		"Xena", "Xara", "Xia",
		"Yara",
		"Zara", "Zoe", "Zara"
	],
	maid: [
		// My fav food
		"Cozonac",
		"Castella", "Magdalena", "Nonnette", "Pavlova", "Tiramisu",
		"Abby", "Ada", "Adelaide", "Alice", "Alma", "Amelia", "Amy", "Anna", "Anne", "Annie",
		"Bea", "Bella", "Belle", "Bess", "Bessie", "Beth", "Betsy", "Betty", "Blanche", "Bonnie",
		"Callie", "Carla", "Carrie", "Cathy", "Cecily", "Clara", "Cora", "Coral", "Cynthia", "Daisy",
		"Dana", "Daphne", "Darla", "Dawn", "Debbie", "Delia", "Della", "Diane", "Dinah", "Dolly",
		"Dora", "Doris", "Dorothy", "Edith", "Edna", "Effie", "Eileen", "Ella", "Ellen", "Elsie",
		"Emma", "Erin", "Esther", "Ethel", "Etta", "Eva", "Eve", "Evelyn", "Fanny", "Faye",
		"Fiona", "Flora", "Florence", "Fran", "Frances", "Gail", "Gemma", "Gertie", "Gina", "Gloria",
		"Grace", "Greta", "Gwen", "Haley", "Hannah", "Harriet", "Hazel", "Heidi", "Helen", "Holly",
		"Ida", "Irene", "Iris", "Isabel", "Ivy", "Jackie", "Jane", "Janet", "Janice", "Jean",
		"Jenny", "Jessie", "Jill", "Joan", "Joanna", "Jody", "Judy", "Julia", "Julie", "June",
		"Kara", "Karen", "Kate", "Kathy", "Katie", "Kay", "Kelly", "Kim", "Kitty", "Laura",
		"Leah", "Leila", "Lena", "Lila", "Lily", "Linda", "Lisa", "Liza", "Lola", "Lora",
		"Lorna", "Lottie", "Louisa", "Lucy", "Lydia", "Lynn", "Mabel", "Macy", "Maggie", "Maisie",
		"Mandy", "Marcia", "Margaret", "Maria", "Marie", "Marion", "Martha", "Mary", "Maud", "Maude",
		"Mavis", "May", "Megan", "Melanie", "Melissa", "Mia", "Mildred", "Millie", "Mina", "Minnie",
		"Mira", "Miranda", "Molly", "Mona", "Muriel", "Myra", "Myrtle", "Nadia", "Nancy", "Nanette",
		"Naomi", "Natalie", "Nell", "Nellie", "Nettie", "Nina", "Nora", "Norma", "Olive", "Olivia",
		"Opal", "Pam", "Pansy", "Pat", "Patty", "Paula", "Peggy", "Penny", "Phoebe", "Polly",
		"Priscilla", "Rachel", "Renee", "Rhoda", "Rita", "Roberta", "Robin", "Rosa", "Rose", "Rosie",
		"Ruby", "Ruth", "Sadie", "Sally", "Samantha", "Sandy", "Sara", "Sharon", "Sheila", "Shelley",
		"Shirley", "Sophie", "Stella", "Sue", "Susan", "Sylvia", "Tara", "Teresa", "Tess", "Tessa",
		"Thelma", "Tina", "Tracy", "Trudy", "Una", "Valerie", "Vera", "Veronica", "Vicky", "Viola",
		"Violet", "Wanda", "Wendy", "Willa", "Winifred", "Winnie", "Yolanda", "Yvonne", "Zara", "Zoe"
	],
	russian: [
		"Ada", "Adelina", "Agniya", "Aida", "Aksinya", "Albina", "Aleksandra", "Alena", "Alina", "Alisa",
		"Anastasiya", "Angela", "Anita", "Anna", "Antonina", "Arina", "Asya", "Aurora", "Avdotya", "Bella",
		"Dana", "Daria", "Dayana", "Diana", "Dina", "Dinara", "Dora", "Dunya", "Eva", "Evgeniya",
		"Faina", "Fekla", "Galina", "Gella", "Gera", "Gleb", "Glenda", "Gloria", "Grusha", "Inga",
		"Inna", "Ira", "Irina", "Iskra", "Iva", "Ivana", "Ivanna", "Izabella", "Jana", "Julia",
		"Kamilla", "Karina", "Katerina", "Katya", "Kira", "Klara", "Kristina", "Lada", "Lana", "Lara",
		"Larisa", "Lena", "Lera", "Lidiya", "Lika", "Liliya", "Lina", "Liza", "Lola", "Luba",
		"Ludmila", "Lyuba", "Makar", "Maksima", "Mara", "Margarita", "Maria", "Marina", "Marta", "Marya",
		"Matryona", "Maya", "Melaniya", "Mila", "Milana", "Milena", "Mira", "Miroslava", "Nadezhda", "Nadia",
		"Nadya", "Nastya", "Natalia", "Natasha", "Nelli", "Nika", "Nina", "Nona", "Oksana", "Olga",
		"Olya", "Pasha", "Paulina", "Pelageya", "Polina", "Rada", "Radmila", "Raisa", "Regina", "Renata",
		"Rima", "Rina", "Rita", "Roksana", "Roma", "Roza", "Rufina", "Ruslana", "Sabina", "Sasha",
		"Serafina", "Sofia", "Sofiya", "Sonya", "Stasya", "Sveta", "Svetlana", "Taisiya", "Tamara", "Tanya",
		"Tara", "Tatiana", "Taya", "Toma", "Uliana", "Valentina", "Valeria", "Varya", "Vasilisa", "Vera",
		"Veronika", "Vika", "Viktoria", "Violetta", "Vita", "Vitaliya", "Vlada", "Yana", "Yaroslava", "Yelena",
		"Yeva", "Yulia", "Yulya", "Yuna", "Zara", "Zhenya", "Zina", "Zinaida", "Zlata", "Zoya"
	],
	elemental: [
		"Aara",
		"Abia",
		"Adara",
		"Aelia",
		"Aeris",
		"Afra",
		"Aila",
		"Aira",
		"Akira",
		"Alaia",
		"Alara",
		"Aleia",
		"Alia",
		"Alina",
		"Alira",
		"Alora",
		"Amara",
		"Ambra",
		"Amia",
		"Amira",
		"Anara",
		"Ania",
		"Anira",
		"Anora",
		"Arda",
		"Aria",
		"Ariana",
		"Arisa",
		"Arya",
		"Asa",
		"Asha",
		"Astra",
		"Aura",
		"Aurora",
		"Ava",
		"Ayana",
		"Ayla",
		"Azara",
		"Azura",
		"Bala",
		"Bela",
		"Bia",
		"Bina",
		"Bira",
		"Blia",
		"Bora",
		"Bria",
		"Calia",
		"Cara",
		"Cassia",
		"Celia",
		"Cera",
		"Chia",
		"Cira",
		"Clara",
		"Cora",
		"Cyra",
		"Dalia",
		"Dana",
		"Dara",
		"Daria",
		"Delia",
		"Dia",
		"Dina",
		"Dora",
		"Drea",
		"Eira",
		"Ela",
		"Elaia",
		"Elara",
		"Elena",
		"Elia",
		"Elina",
		"Elira",
		"Elora",
		"Elyra",
		"Emara",
		"Emia",
		"Emira",
		"Ena",
		"Enya",
		"Era",
		"Eria",
		"Eris",
		"Erya",
		"Esra",
		"Estia",
		"Etta",
		"Eva",
		"Evana",
		"Evia",
		"Evira",
		"Eyla",
		"Ezra",
		"Fara",
		"Fayra",
		"Fia",
		"Fina",
		"Flora",
		"Freya",
		"Gala",
		"Gara",
		"Gia",
		"Gina",
		"Gira",
		"Glora",
		"Haia",
		"Hana",
		"Hara",
		"Helia",
		"Hera",
		"Hila",
		"Iana",
		"Iara",
		"Ila",
		"Ilia",
		"Ilira",
		"Ilora",
		"Ina",
		"Inara",
		"Ira",
		"Iria",
		"Iris",
		"Isa",
		"Isra",
		"Iva",
		"Ivana",
		"Ivia",
		"Ivira",
		"Iya",
		"Izara",
		"Izora",
		"Jada",
		"Jana",
		"Jara",
		"Jaya",
		"Jia",
		"Jina",
		"Jira",
		"Jora",
		"Kaia",
		"Kala",
		"Kara",
		"Kasia",
		"Kaya",
		"Kayra",
		"Keira",
		"Kia",
		"Kina",
		"Kira",
		"Kora",
		"Kyla",
		"Kyra",
		"Lana",
		"Lara",
		"Laya",
		"Lea",

		"Lena",
		"Lia",
		"Lila",
		"Lina",
		"Lira",
		"Lora",
		"Luna",
		"Lyra",
		"Mada",
		"Mala",
		"Mara",
		"Maya",
		"Mayra",
		"Mela",
		"Mia",
		"Mila",
		"Mina",
		"Mira",
		"Mora",
		"Myra",
		"Nadia",
		"Nala",
		"Nara",
		"Naya",
		"Nayra",
		"Nela",
		"Nia",
		"Nila",
		"Nina",
		"Nira",
		"Nora",
		"Nyra",
		"Oana",
		"Ola",
		"Olina",
		"Ora",
		"Orla",
		"Oya",
		"Rana",
		"Raya",
		"Rea",
		"Reia",
		"Rena",
		"Ria",
		"Rila",
		"Rina",
		"Risa",
		"Riya",
		"Rora",
		"Ryla",
		"Ryna",
		"Saba",
		"Sada",
		"Sana",
		"Sara",
		"Saya",
		"Sayra",
		"Sela",
		"Sia",
		"Sila",
		"Sina",
		"Sira",
		"Sola",
		"Sora",
		"Syla",
		"Syra",
		"Tala",
		"Tara",
		"Taya",
		"Tayra",
		"Tela",
		"Tia",
		"Tila",
		"Tina",
		"Tira",
		"Tora",
		"Tyra",
		"Ula",
		"Una",
		"Ura",
		"Ursa",
		"Vala",
		"Vana",
		"Vara",
		"Vaya",
		"Vela",
		"Via",
		"Vila",
		"Vina",
		"Vira",
		"Vola",
		"Vora",
		"Vyra",
		"Xara",
		"Xia",
		"Xina",
		"Xira",
		"Xora",
		"Yana",
		"Yara",
		"Yela",
		"Yia",
		"Yila",
		"Yina",
		"Yira",
		"Yora",
		"Yula",
		"Yura",
		"Zara",
		"Zaya",
		"Zela",
		"Zia",
		"Zila",
		"Zina",
		"Zira",
		"Zola",
		"Zora",
		"Zyla",
		"Zyra"
	],
	witch: [
		"Circe",
		"Abigail", "Agatha", "Agnes", "Alecto", "Alexis", "Alice", "Alma", "Althea", "Alyssa", "Amara",
		"Amber", "Amelia", "Angelica", "Anita", "Annabelle", "Ariana", "Ariel", "Artemis", "Astra", "Athena",
		"Aurora", "Avery", "Bailey", "Beatrice", "Beatrix", "Bellatrix", "Bianca", "Blair", "Bonnie", "Bree",
		"Bridget", "Buffy", "Callie", "Calliope", "Cara", "Cassandra", "Cecilia", "Celeste", "Celia", "Celine",
		"Charity", "Charlotte", "Chloe", "Christine", "Circe", "Clara", "Clarissa", "Cleo", "Cora", "Cordelia",
		"Cynthia", "Dahlia", "Daphne", "Darcy", "Davina", "Delia", "Delilah", "Diana", "Dora", "Dorothy",
		"Eden", "Edith", "Elena", "Eliza", "Elizabeth", "Ella", "Ellie", "Eloise", "Elsa", "Elsie",
		"Elvira", "Ember", "Emilia", "Emily", "Emma", "Enid", "Erica", "Esme", "Estelle", "Esther",
		"Eva", "Eve", "Evelyn", "Faye", "Fiona", "Flora", "Freya", "Gabrielle", "Garnet", "Genevieve",
		"Gillian", "Ginevra", "Glenda", "Gloria", "Grace", "Gwen", "Gwendolyn", "Haley", "Hanna", "Harmony",
		"Hazel", "Heather", "Hecate", "Helena", "Hermione", "Hilda", "Holly", "Hope", "Imogen", "Ingrid",
		"Iris", "Isabel", "Isadora", "Isla", "Ivy", "Jade", "Jasmine", "Jenna", "Jennifer", "Jessica",
		"Jill", "Joan", "Jocelyn", "Josephine", "Joyce", "Julia", "Juliet", "June", "Kara", "Karen",
		"Katrina", "Kayla", "Keira", "Kendra", "Kira", "Kylie", "Lana", "Lara", "Laura", "Laurel",
		"Layla", "Leah", "Leila", "Lena", "Leonora", "Lila", "Lilith", "Lillian", "Lily", "Linda",
		"Lisa", "Lola", "Lorelei", "Lorna", "Louisa", "Lucia", "Lucille", "Lucinda", "Lucy", "Luna",
		"Lydia", "Lyra", "Mabel", "Macy", "Madeline", "Maeve", "Maggie", "Malia", "Mallory", "Mara",
		"Margot", "Maria", "Marie", "Marina", "Marion", "Marissa", "Marta", "Matilda", "Maya", "Melanie",
		"Melinda", "Melissa", "Mia", "Mila", "Mildred", "Mina", "Mira", "Miranda", "Molly", "Mona",
		"Morgan", "Myra", "Myrtle", "Nadia", "Nancy", "Naomi", "Natalie", "Nell", "Nessa", "Nicole",
		"Nina", "Nora", "Nova", "Octavia", "Olive", "Olivia", "Opal", "Ophelia", "Paige", "Pamela",
		"Pandora", "Patience", "Patricia", "Paula", "Pearl", "Penelope", "Phoebe", "Piper", "Poppy", "Priscilla",
		"Prue", "Rachel", "Raina", "Ramona", "Rebecca", "Regina", "Renee", "Rhiannon", "Riley", "Rita",
		"Robin", "Robyn", "Romy", "Rosalie", "Rose", "Rosemary", "Rowan", "Ruby", "Ruth", "Sabrina",
		"Sadie", "Sage", "Samantha", "Sandra", "Sara", "Sarah", "Scarlett", "Selena", "Serena", "Shannon",
		"Shay", "Sheila", "Shelby", "Shirley", "Sienna", "Sierra", "Simone", "Skye", "Sofia", "Sonya",
		"Stella", "Stephanie", "Summer", "Sybil", "Sydney", "Sylvia", "Tabitha", "Talia", "Tamara", "Tara",
		"Tatiana", "Tessa", "Thea", "Theresa", "Tia", "Tiffany", "Tracy", "Trinity", "Ursula", "Valeria",
		"Vanessa", "Veronica", "Victoria", "Violet", "Vivian", "Wanda", "Wendy", "Willow"],
	aztec: [
		"Huixtoci",
		"Chanti",
		"Meztli",
		"Chalchi",
		"Tlazol",
		"Mictecaci",
		"Citlali",
		"Natah",
		"Nena",
		"Tonaca",
		"Tlaltec",
		"Chicome",
		"Xilonen",
		"Coatli",
		"Chimalma",
		"Xochi",
		"Itzpa",
		"Toci",
		"Tzitzi",
		"Xolotl",
		"Nemonten",
		"Tezcatli",
		"Mimix",
		"Xolotl",
		"Atlahua",
		"Quetzal",
		"Tonatiuh",
	],


	space: [
		"Kepler",
		"Hubble",
		"Webb",
		"Schwarzschild",
		"Kerr",
		"Agrippa",
		"Arzachel",
		"Casaba",
		"Cassini",
		"Chandrasekhar",
		"Drake",
		"Galilei",
		"Geller",
		"Kidinnu",
		"Lagadha",
		"Messier",
		"Murakami",
		"Oikawa",
		"Copernicus",
		"Copernicus",

		// region cookie if you know these
		"Pluto",
		"Saturn",
		"Luna-Terra",
		// endregion


		"Selene",
		"Luna",
		"Laniakea",
		"Void",
		"Magellan",
		"Rigel",
		"Rayet",
		"Sagitta",
		"Voyager",
		"Alcyon",
		"Seyfert",
		"Quasar",
		"Redshift",
		"Cosmos",
		"Axion",
		"Vector",
		"Nova",
		"Wolf",
		"Spectra",
		"Yerkes",
		"Herschel",
		"Asymptote",
		"Gaia",
		"Akatsuki",
		"Psyche",
		"Juno",
		"Lucy",
		"Danuri",
		"Hera",
		"Chang'e",
		"Osiris",
		"Gagarin",
		"Glenn",
		"Armstrong",
		"Aldrin",
		"Apollo",
		"Challenger",
		"Artemis",
		"Titan",
		"Io",
		"Europa",
		"Ganymede",
		"Mercury",
		"Sputnik",

		"Andromeda",
		"Antlia",
		"Apus",
		"Aquarius",
		"Aquila",
		"Ara",
		"Aries",
		"Auriga",
		"Boötes",
		"Caelum",
		"Camelopardalis",
		"Cancer",
		"Canis",
		"Capricornus",
		"Carina",
		"Cassiopeia",
		"Centaurus",
		"Cepheus",
		"Cetus",
		"Chamaeleon",
		"Circinus",
		"Columba",
		"Coma",
		"Berenices",
		"Corona",
		"Borealis",
		"Corvus",
		"Crater",
		"Crux",
		"Cygnus",
		"Delphinus",
		"Dorado",
		"Draco",
		"Equuleus",
		"Eridanus",
		"Fornax",
		"Gemini",
		"Grus",
		"Hercules",
		"Horologium",
		"Hydra",
		"Hydrus",
		"Indus",
		"Lacerta",
		"Leo",
		"Lepus",
		"Libra",
		"Lupus",
		"Lynx",
		"Lyra",
		"Mensa",
		"Microscopium",
		"Monoceros",
		"Musca",
		"Norma",
		"Octans",
		"Ophiuchus",
		"Orion",
		"Pavo",
		"Pegasus",
		"Perseus",
		"Phoenix",
		"Pictor",
		"Pisces",
		"Piscis",
		"Puppis",
		"Pyxis",
		"Reticulum",
		"Sagitta",
		"Sagittarius",
		"Scorpius",
		"Sculptor",
		"Scutum",
		"Serpens",
		"Sextans",
		"Taurus",
		"Telescopium",
		"Triangulum",
		"Tucana",
		"Ursa",
		"Vela",
		"Virgo",
		"Volans",
		"Vulpecula",
	],
	italian: [
		"Abriana",
		"Ada",
		"Adalgisa",
		"Adelina",
		"Adriana",
		"Agata",
		"Agnesa",
		"Aida",
		"Alessa",
		"Alessandra",
		"Alessia",
		"Alfonsina",
		"Alice",
		"Alina",
		"Allegra",
		"Alma",
		"Aloisa",
		"Amalia",
		"Amanda",
		"Amara",
		"Ambra",
		"Amelia",
		"Anastasia",
		"Andrea",
		"Angela",
		"Angelica",
		"Angelina",
		"Anita",
		"Anna",
		"Annabella",
		"Annalisa",
		"Antonia",
		"Aria",
		"Ariana",
		"Arianna",
		"Artemisia",
		"Asia",
		"Assunta",
		"Astra",
		"Aurora",
		"Bambi",
		"Barbara",
		"Battista",
		"Beata",
		"Beatrice",
		"Bella",
		"Benedetta",
		"Bianca",
		"Bibiana",
		"Blanca",
		"Brigida",
		"Bruna",
		"Camila",
		"Camilla",
		"Candida",
		"Caprice",
		"Carina",
		"Carla",
		"Carlotta",
		"Carmela",
		"Carmen",
		"Carola",
		"Carolina",
		"Cassandra",
		"Caterina",
		"Cecilia",
		"Celeste",
		"Celia",
		"Chiara",
		"Cinzia",
		"Clara",
		"Claudia",
		"Clementina",
		"Clio",
		"Colomba",
		"Concetta",
		"Consuelo",
		"Cora",
		"Coralia",
		"Cosima",
		"Cristina",
		"Dafne",
		"Dalia",
		"Dana",
		"Daniela",
		"Daria",
		"Debora",
		"Delia",
		"Diana",
		"Diletta",
		"Dina",
		"Dolores",
		"Donatella",
		"Dora",
		"Dorotea",
		"Eda",
		"Edith",
		"Elena",
		"Eleonora",
		"Elia",
		"Elisa",
		"Elisabetta",
		"Ella",
		"Elsa",
		"Elvira",
		"Emilia",
		"Emma",
		"Enrica",
		"Erica",
		"Erika",
		"Erminia",
		"Ester",
		"Eva",
		"Fabiana",
		"Fabrizia",
		"Federica",
		"Felicia",
		"Fiamma",
		"Fiammetta",
		"Filippa",
		"Filomena",
		"Fiorella",
		"Fiorenza",
		"Flaminia",
		"Flavia",
		"Flora",
		"Florence",
		"Francesca",
		"Gabriela",
		"Gabriella",
		"Gaia",
		"Gemma",
		"Gia",
		"Giada",
		"Gianna",
		"Ginevra",
		"Gioia",
		"Giorgia",
		"Giorgina",
		"Giovanna",
		"Giulia",
		"Giuliana",
		"Giuseppina",
		"Gloria",
		"Graziella",
		"Greta",
		"Griselda",
		"Guendalina",
		"Guida",
		"Ida",
		"Ilaria",
		"Imelda",
		"Ines",
		"Iolanda",
		"Irene",
		"Iris",
		"Irma",
		"Isa",
		"Isabella",
		"Isadora",
		"Isotta",
		"Ivana",
		"Ivonne",
		"Jade",
		"Jasmine",
		"Jessica",
		"Jolanda",
		"Julia",
		"Karina",
		"Katia",
		"Kira",
		"Laila",
		"Lara",
		"Laura",
		"Lauretta",
		"Lavinia",
		"Lea",
		"Leila",
		"Lelia",
		"Lena",
		"Leonora",
		"Letizia",
		"Lia",
		"Liana",
		"Lidia",
		"Liliana",
		"Linda",
		"Lisa",
		"Livia",
		"Lola",
		"Lorena",
		"Loretta",
		"Lorna",
		"Luana",
		"Lucia",
		"Luciana",
		"Lucrezia",
		"Ludovica",
		"Luisa",
		"Luna",
		"Maddalena",
		"Magda",
		"Maida",
		"Manuela",
		"Mara",
		"Marcella",
		"Margherita",
		"Maria",
		"Marianna",
		"Marica",
		"Marilena",
		"Marina",
		"Marisa",
		"Marta",
		"Martina",
		"Marzia",
		"Matilde",
		"Maura",
		"Mauro",
		"Melania",
		"Melissa",
		"Mia",
		"Michela",
		"Milena",
		"Mina",
		"Miranda",
		"Miriam",
		"Mirta",
		"Monica",
		"Nadia",
		"Natalia",
		"Natalina",
		"Nella",
		"Nerina",
		"Nicoletta",
		"Nina",
		"Noemi",
		"Nora",
		"Norma",
		"Novella",
		"Olga",
		"Olivia",
		"Oriana",
		"Ornella",
		"Orsola",
		"Ottavia",
		"Paola",
		"Patrizia",
		"Perla",
		"Petra",
		"Pia",
		"Piera",
		"Pietra",
		"Prisca",
		"Priscilla",
		"Quinta",
		"Rachele",
		"Raffaella",
		"Rebecca",
		"Regina",
		"Renata",
		"Riccarda",
		"Rina",
		"Rita",
		"Roberta",
		"Roma",
		"Romana",
		"Romina",
		"Rosa",
		"Rosalia",
		"Rosanna",
		"Rosaria",
		"Rosella",
		"Rosetta",
		"Rossana",
		"Rossella",
		"Roxana",
		"Sabina",
		"Sabrina",
		"Samantha",
		"Sandra",
		"Sara",
		"Savina",
		"Selena",
		"Selma",
		"Serena",
		"Sergio",
		"Sibilla",
		"Silvana",
		"Silvia",
		"Simona",
		"Sofia",
		"Sonia",
		"Stefania",
		"Stella",
		"Susanna",
		"Tania",
		"Tatiana",
		"Tecla",
		"Teresa",
		"Tessa",
		"Tina",
		"Tiziana",
		"Tommasa",
		"Umberta",
		"Valeria",
		"Valeriana",
		"Vanessa",
		"Vanna",
		"Vera",
		"Veronica",
		"Viola",
		"Virginia",
		"Vittoria",
		"Viviana",
		"Zara",
		"Zelinda",
		"Zita",
		"Zoe"
	],
	Fuuka: ["Fuuka Windsong"],
	TheWarden: ["Dawn Carver"],
	TheWardenFighter: ["Citrina"],
	TheWardenWizard: ["Agatha"],
	TheWardenRogue: ["Luna"],
	TheWardenDoll: ["Doll #51"],
	Dollmaker: ["Catherine Willows"],
	MaidKnightHeavy: ["Saryth"],
	MaidKnightLight: ["Alisza"],
	chinese: [
		"Ai",
		"Aimei",
		"Anli",
		"Bai",
		"Bao",
		"Bei",
		"Bing",
		"Cai",
		"Caihong",
		"Caiyun",
		"Can",
		"Chang",
		"Chao",
		"Chen",
		"Cheng",
		"Chou",
		"Chu",
		"Chun",
		"Chunhua",
		"Chunlan",
		"Chunli",
		"Chunyan",
		"Chunying",
		"Cong",
		"Cuifen",
		"Dai",
		"Daiyu",
		"Dan",
		"Dandan",
		"Danyang",
		"Deng",
		"Dong",
		"Dongmei",
		"En",
		"Fang",
		"Fangfang",
		"Fanghua",
		"Fangyuan",
		"Fei",
		"Feifei",
		"Fen",
		"Feng",
		"Fengge",
		"Fenghua",
		"Fenglan",
		"Fengling",
		"Fengyun",
		"Fu",
		"Fuyao",
		"Fuyu",
		"Gan",
		"Gang",
		"Ge",
		"Gen",
		"Guang",
		"Guifen",
		"Guihua",
		"Guilan",
		"Guirong",
		"Guixiang",
		"Guo",
		"Hai",
		"Haifeng",
		"Hailan",
		"Haiyan",
		"Haiying",
		"Han",
		"Hanhua",
		"Hanyu",
		"He",
		"Hei",
		"Heng",
		"Hong",
		"Hongmei",
		"Hongxia",
		"Hongyan",
		"Hongyu",
		"Hou",
		"Hua",
		"Huahua",
		"Huai",
		"Huan",
		"Huanyu",
		"Hui",
		"Huifang",
		"Huifen",
		"Huihui",
		"Huiling",
		"Huimin",
		"Huiqing",
		"Huirong",
		"Huiying",
		"Huiyun",
		"Jia",
		"Jiahui",
		"Jiali",
		"Jian",
		"Jiang",
		"Jiao",
		"Jie",
		"Jielin",
		"Jin",
		"Jing",
		"Jingjing",
		"Jingyi",
		"Jingyu",
		"Jinhua",
		"Jinlan",
		"Jinmei",
		"Jinping",
		"Jinyu",
		"Jiuyue",
		"Ju",
		"Juan",
		"Jue",
		"Jun",
		"Junjie",
		"Junlan",
		"Junru",
		"Juxia",
		"Kai",
		"Kaihua",
		"Kaiyu",
		"Kang",
		"Kun",
		"Lan",
		"Lanfen",
		"Lanhua",
		"Lanlan",
		"Lanying",
		"Lei",
		"Lian",
		"Liang",
		"Lianhua",
		"Liangliang",
		"Liangying",
		"Liangyu",
		"Liao",
		"Lian",
		"Liang",
		"Lihua",
		"Lijuan",
		"Lili",
		"Liling",
		"Limei",
		"Limin",
		"Lin",
		"Lina",
		"Ling",
		"Lingling",
		"Lingyun",
		"Linlin",
		"Liping",
		"Liqin",
		"Liqing",
		"Lirong",
		"Liwei",
		"Liwen",
		"Liyan",
		"Liying",
		"Liyu",
		"Liyun",
		"Lizhen",
		"Lizi",
		"Long",
		"Luan",
		"Luli",
		"Lulu",
		"Lun",
		"Luo",
		"Luping",
		"Luyu",
		"Mai",
		"Man",
		"Mao",
		"Mei",
		"Meifen",
		"Meihua",
		"Meijuan",
		"Meili",
		"Meiling",
		"Meimei",
		"Meirong",
		"Meixiang",
		"Meixiu",
		"Meiyu",
		"Meizhen",
		"Meng",
		"Menghua",
		"Mengmeng",
		"Miao",
		"Min",
		"Ming",
		"Minghua",
		"Mingli",
		"Mingmei",
		"Mingxia",
		"Mingyu",
		"Mingzhu",
		"Nan",
		"Nana",
		"Ning",
		"Ningning",
		"Niu",
		"Nuan",
		"Pei",
		"Peifen",
		"Peihua",
		"Peipei",
		"Peng",
		"Ping",
		"Pingping",
		"Qian",
		"Qiang",
		"Qiao",
		"Qiaoyun",
		"Qin",
		"Qing",
		"Qingge",
		"Qinghua",
		"Qinglan",
		"Qingling",
		"Qingmei",
		"Qingqing",
		"Qingshan",
		"Qingyuan",
		"Qingyun",
		"Qiong",
		"Qiu",
		"Qiuyue",
		"Quan",
		"Ran",
		"Rong",
		"Ronghua",
		"Rongrong",
		"Ru",
		"Rui",
		"Ruirui",
		"Ruyi",
		"Ruyu",
		"San",
		"Shan",
		"Shanhua",
		"Shanli",
		"Shanshan",
		"Shao",
		"Shen",
		"Sheng",
		"Shi",
		"Shuang",
		"Shuangshuang",
		"Shui",
		"Shun",
		"Shu",
		"Shufen",
		"Shuhua",
		"Shui",
		"Shun",
		"Shu",
		"Shufen",
		"Shuhua",
		"Shujun",
		"Shulan",
		"Shuli",
		"Shumei",
		"Shun",
		"Shuyi",
		"Shuyu",
		"Shuzhen",
		"Song",
		"Sufen",
		"Suhua",
		"Sui",
		"Suyin",
		"Suyu",
		"Suzhen",
		"Tao",
		"Tian",
		"Ting",
		"Tingting",
		"Tong",
		"Tongtong",
		"Wei",
		"Weifen",
		"Weihua",
		"Weili",
		"Weimei",
		"Weiping",
		"Weixia",
		"Weiyu",
		"Wen",
		"Wenhua",
		"Wenjing",
		"Wenli",
		"Wenping",
		"Wenwen",
		"Xia",
		"Xiafen",
		"Xiaohong",
		"Xiaohua",
		"Xiaojing",
		"Xiaolan",
		"Xiaoli",
		"Xiaoling",
		"Xiaomei",
		"Xiaoping",
		"Xiaoyan",
		"Xiaoying",
		"Xiaoyu",
		"Xiaozhen",
		"Xie",
		"Xin",
		"Xing",
		"Xingxing",
		"Xinlan",
		"Xinru",
		"Xinyi",
		"Xinyu",
		"Xiu",
		"Xiulan",
		"Xiuli",
		"Xiumei",
		"Xiumin",
		"Xiuying",
		"Xue",
		"Xuefen",
		"Xuehua",
		"Xueli",
		"Xuemei",
		"Xueping",
		"Xueyan",
		"Xueying",
		"Xun",
		"Yafen",
		"Yahui",
		"Yali",
		"Yan",
		"Yanfen",
		"Yanhong",
		"Yanhua",
		"Yanli",
		"Yanling",
		"Yanmei",
		"Yanping",
		"Yanru",
		"Yanxia",
	],
	vampire: [
		"Abriana",
		"Ada",
		"Adrielle",
		"Agrippina",
		"Ailith",
		"Akasha",
		"Akshayaa",
		"Alina",
		"Amalia",
		"Amaris",
		"Ambra",
		"Ambrosia",
		"Amelia",
		"Amira",
		"Anastasia",
		"Anne",
		"Artemisia",
		"Asra",
		"Astra",
		"Aurora",
		"Azrael",
		"Bambi",
		"Belladonna",
		"Bianca",
		"Briar",
		"Camilla",
		"Carmen",
		"Cassandra",
		"Catherine",
		"Celeste",
		"Celia",
		"Chime",
		"Ciarra",
		"Cinzia",
		"Clara",
		"Cora",
		"Coralia",
		"Cosima",
		"Crimson",
		"Daeva",
		"Dahlia",
		"Dana",
		"Darcia",
		"Darya",
		"Debora",
		"Delia",
		"Desdemona",
		"Diana",
		"Dina",
		"Drusilla",
		"Edith",
		"Elena",
		"Elisaria",
		"Elvira",
		"Enyo",
		"Erica",
		"Esmeray",
		"Essie",
		"Eva",
		"Fala",
		"Fiamma",
		"Fiona",
		"Flora",
		"Gemma",
		"Gia",
		"Gisela",
		"Godfrey",
		"Graziella",
		"Griselda",
		"Guendalina",
		"Ida",
		"Ines",
		"Iris",
		"Isadora",
		"Isotta",
		"Ivonne",
		"Jade",
		"Jezebel",
		"Jett",
		"Jolanda",
		"Julia",
		"Keket",
		"Kira",
		"Laila",
		"Lara",
		"Leila",
		"Lena",
		"Leonora",
		"Letizia",
		"Lia",
		"Lilith",
		"Livia",
		"Lola",
		"Lorena",
		"Lucia",
		"Lucrezia",
		"Luna",
		"Maddalena",
		"Magda",
		"Magnifica",
		"Mara",
		"Marcella",
		"Marianna",
		"Marina",
		"Maryse",
		"Matilde",
		"Melania",
		"Melissa",
		"Mia",
		"Mina",
		"Miranda",
		"Mira",
		"Mirta",
		"Monica",
		"Nadia",
		"Natalia",
		"Nella",
		"Nerezza",
		"Nerina",
		"Nina",
		"Noemi",
		"Nora",
		"Novella",
		"Olga",
		"Olivia",
		"Oriana",
		"Ornella",
		"Perla",
		"Petra",
		"Pia",
		"Piera",
		"Polemia",
		"Prisca",
		"Rachele",
		"Raven",
		"Rebecca",
		"Regina",
		"Renata",
		"Rina",
		"Roma",
		"Romina",
		"Rosa",
		"Rosalia",
		"Rosaria",
		"Rosceline",
		"Rosella",
		"Roxana",
		"Sabina",
		"Sabrina",
		"Samara",
		"Samantha",
		"Sandra",
		"Sara",
		"Selena",
		"Selma",
		"Serena",
		"Sibilla",
		"Silvia",
		"Simona",
		"Sofia",
		"Stella",
		"Susanna",
		"Tania",
		"Tatiana",
		"Thana",
		"Tina",
		"Valeria",
		"Vanessa",
		"Vera",
		"Veronica",
		"Viola",
		"Vittoria",
		"Viviana",
		"Zara",
		"Zelinda",
		"Zita",
		"Zoe"
	],
	french: [
		"Abella",
		"Adalie",
		"Adeline",
		"Adrienne",
		"Aimee",
		"Alaine",
		"Albertine",
		"Alice",
		"Aline",
		"Alizee",
		"Amalie",
		"Amelie",
		"Anais",
		"Angele",
		"Angelique",
		"Annette",
		"Anouk",
		"Antoinette",
		"Ariane",
		"Arielle",
		"Astrid",
		"Audrey",
		"Aurelie",
		"Aveline",
		"Axelle",
		"Babette",
		"Beatrice",
		"Belle",
		"Bernadette",
		"Blanche",
		"Brigitte",
		"Camille",
		"Candice",
		"Capucine",
		"Carine",
		"Carla",
		"Carole",
		"Caroline",
		"Catherine",
		"Cecile",
		"Celeste",
		"Celine",
		"Cerise",
		"Chantal",
		"Charlotte",
		"Chloe",
		"Christelle",
		"Christiane",
		"Christine",
		"Claire",
		"Clara",
		"Clarisse",
		"Claudette",
		"Claudine",
		"Colette",
		"Coline",
		"Constance",
		"Coralie",
		"Coraline",
		"Corinne",
		"Cosette",
		"Danielle",
		"Daphne",
		"Delphine",
		"Denise",
		"Diane",
		"Dominique",
		"Edith",
		"Elaine",
		"Eleanor",
		"Eleonore",
		"Elise",
		"Elodie",
		"Eloise",
		"Emeline",
		"Emilie",
		"Emma",
		"Emmanuelle",
		"Esme",
		"Estelle",
		"Eugenie",
		"Eulalie",
		"Eve",
		"Evelyn",
		"Fabienne",
		"Fantine",
		"Fay",
		"Faye",
		"Felicie",
		"Fiona",
		"Flavie",
		"Fleur",
		"Florence",
		"Floriane",
		"Francoise",
		"Gabrielle",
		"Gaia",
		"Genevieve",
		"Georgette",
		"Georgine",
		"Geraldine",
		"Ghislaine",
		"Gigi",
		"Gilberte",
		"Ginette",
		"Gisele",
		"Giselle",
		"Helene",
		"Heloise",
		"Henriette",
		"Hortense",
		"Ines",
		"Irene",
		"Iris",
		"Isabeau",
		"Isabelle",
		"Isaline",
		"Isolde",
		"Jacqueline",
		"Jade",
		"Janine",
		"Jeanne",
		"Jeannette",
		"Jeannine",
		"Joceline",
		"Jocelyne",
		"Joelle",
		"Josephine",
		"Josette",
		"Josiane",
		"Julia",
		"Julie",
		"Juliette",
		"Justine",
		"Karine",
		"Katell",
		"Kathleen",
		"Katia",
		"Katrine",
		"Laetitia",
		"Lara",
		"Laura",
		"Laure",
		"Laurel",
		"Laurene",
		"Laurentine",
		"Laurie",
		"Layla",
		"Lea",
		"Leila",
		"Leonie",
		"Lila",
		"Liliane",
		"Lilou",
		"Lina",
		"Linda",
		"Line",
		"Lise",
		"Lisette",
		"Livia",
		"Lola",
		"Lorelei",
		"Lorraine",
		"Lou",
		"Louane",
		"Louisa",
		"Louise",
		"Lucie",
		"Lucienne",
		"Lucile",
		"Lucille",
		"Ludivine",
		"Luna",
		"Lyla",
		"Lydie",
		"Lynette",
		"Madeleine",
		"Magali",
		"Magalie",
		"Maelle",
		"Maeva",
		"Manon",
		"Marceline",
		"Margaux",
		"Margot",
		"Marguerite",
		"Mariam",
		"Marie",
		"Marie-Claire",
		"Marie-France",
		"Marie-Laure",
		"Marie-Noelle",
		"Marie-Pierre",
		"Marina",
		"Marine",
		"Marion",
		"Marise",
		"Marjorie",
		"Marlene",
		"Martine",
		"Mathilde",
		"Maude",
		"Maud",
		"Maurine",
		"Maxime",
		"Maxine",
		"Maya",
		"Melanie",
		"Melina",
		"Melissa",
		"Melodie",
		"Mercedes",
		"Michelle",
		"Mila",
		"Mireille",
		"Mirella",
		"Mirelle",
		"Monique",
		"Morgane",
		"Myriam",
		"Nadia",
		"Nadine",
		"Nanette",
		"Natalie",
		"Nathalie",
		"Nelly",
		"Nicole",
		"Nicolette",
		"Nina",
		"Noa",
		"Noelie",
		"Noelle",
		"Noemie",
		"Nora",
		"Odette",
		"Odile",
		"Olive",
		"Olivia",
		"Olympe",
		"Ophelie",
		"Paola",
		"Paule",
		"Paulette",
		"Pauline",
		"Perrine",
		"Philippine",
		"Philomene",
		"Phoebe",
		"Pia",
		"Pierrette",
		"Priscille",
		"Prune",
		"Quitterie",
		"Rachel",
		"Raphaelle",
		"Rebecca",
		"Reine",
		"Renee",
		"Rochelle",
		"Romane",
		"Romy",
		"Rosalie",
		"Rosanne",
		"Rose",
		"Rose-Marie",
		"Roseline",
		"Rosine",
		"Roxane",
		"Roxanne",
		"Sabine",
		"Sabrina",
		"Salome",
		"Sandrine",
		"Sara",
		"Sarah",
		"Sasha",
		"Savannah",
		"Severine",
		"Simone",
		"Sixtine",
		"Solange",
		"Soleil",
		"Solenne",
		"Sonia",
		"Sophia",
		"Sophie",
		"Stella",
		"Suzanne",
		"Suzette",
		"Sylvia",
		"Sylvie",
		"Talia",
		"Tatiana",
		"Thais",
		"Therese",
		"Tiffany",
		"Valentine",
		"Valerie",
		"Vanessa",
		"Vera",
		"Veronique",
		"Victoire",
		"Victoria",
		"Violette",
		"Virginie",
		"Viviane",
		"Vivienne",
		"Yasmina",
		"Yolande",
		"Yseult",
		"Yvette",
		"Yvonne",
		"Zara",
		"Zoe",
		"Zoey"
	],
	science: [
		"Aryabhatta",
		"Alcubierre",
		"Alhazen",
		"Archimedes",
		"Avicenna",
		"Asimov",
		"Banks",
		"Bernoulli",
		"Bohr",
		"Bosscha",
		"Casimir",
		"Chernokov",
		"Newton",
		"Curie",
		"Dirac",
		"Doppler",
		"Eigen",
		"Faraday",
		"Fermi",
		"Mach",
		"Fourier",
		"Geiger",
		"Euler",
		"Goddard",
		"Hamilton",
		"Heisenberg",
		"Neumann",
		"Turing",
		"Huygens",
		"Kaku",
		"Maiani",
		"Navarro",
		"Nezan",
		"Ohm",
		"Poincare",
		"Qian",
		"Rayleigh",
		"Reynolds",
		"Schrodinger",
		"Desitter",
		"Teller",
		"Dyson",
		"Ampere",
		"Watt",
		"Volt",
		"Coloumb",
		"Einstein",
		"Laplace",
		"Yukawa",
		"Celsius",
		"Kelvin",
		"Hawking",
		"Maxwell",
		"Weber",
		"Fresnel",
		"da Vinci",
		"Boole",
		"Hilbert",
		"Pascal",
		"Penrose",
	],
	cthulu: [
		"Oukranos",
		"Lobon",
		"Horthath",
		"Tamash",
		"Zo-Kalar",
		"Hagarg",
		"Ryonis",
		"Karakal",
		"Abhoth",
		"Aiueb",
		"Aletheia",
		"Azathoth",
		"Azathoth",
		"Azhorra",
		"Blackness",
		"C'thalpa",
		"Cxaxukluth",
		"Daoloth",
		"Darkness",
		"D'endrrah",
		"Hydra",
		"Ialdagorth",
		"Lukthu",
		"Mh'ithrha",
		"Nameless",
		"Korath",
		"Nyarlathotep",
		"Nyctelios",
		"Atheron",
		"Rakath",
		"Trunembra",
		"Tulzscha",
		"Xa'ligha",
		"Xexanoth",
		"Yidhra",
		"Yog-Sothoth",
		"Shavalyoth",
		"Yaggdytha",
		"Yig",
		"Cthylla",
		"Ctoggha",
		"Dythalla",
		"Ei'lor",
		"Kaunuzoth",
		"Shista",
		"Swarog",
		"Xitalu",
		"Yamath",
		"Ythogtha",
		"Yorith",
		"Rokon",
		"Perse",
		"Oorn",
		"Annihilation",
	],
	demon: [
		// The demon that answers when you call its name
		"Chara",

		"Babylon",
		"Akhkhazu",
		"Alara",
		"Artemis",
		"Astra",
		"Axe",
		"Azura",
		"Bardiche",
		"Batibat",
		"Blade",
		"Bow",
		"Caliver",
		"Catapult",
		"Chamunda",
		"Charmo",
		"Chedipe",
		"Chesma",
		"Chordeva",
		"Crossbow",
		"Culverin",
		"Dagger",
		"Dakini",
		"Daruka",
		"Dia",
		"Dracon",
		"Drea",
		"Durukti",
		"Estoc",
		"Falconet",
		"Flail",
		"Flame",
		"Futakuchi",
		"Glaive",
		"Griselda",
		"Guisarme",
		"Gungdo",
		"Gwisin",
		"Halberd",
		"Hanako",
		"Hankyu",
		"Hannya",
		"Harionago",
		"Hashihime",
		"Hatchet",
		"Hone",
		"Huli",
		"Iara",
		"Iris",
		"Istinggar",
		"Javelin",
		"Jiaozhi",
		"Jorogumo",
		"Kali",
		"Katana",
		"Kestros",
		"Kira",
		"Kora",
		"Krasue",
		"Kumiho",
		"Kunai",
		"Lance",
		"Lantaka",
		"Mace",
		"Maeve",
		"Mangonel",
		"Mara",
		"Messina",
		"Mina",
		"Paimon",
		"Sara",
		"Saya",
		"Scythe",
		"Shuri",
		"Shuriken",
		"Sira",
		"Spear",
		"Sword",
		"Tarrasque",
		"Minokawa",
		"Balaur",
		"Strigoi",
		"Zmei",
		"Grendel",
		"Messer",
		"Daikyu",
		"Gungdo",
		"Hankyu",
		"Skane",
		"Maul",
		"Culverin",
		"Hwacha",
		"Kage",
		"Khopesh",
		"Nimcha",
		"Shashka",
		"Dao",
		"Tsurugi",
		"Kodachi",
		"Bolo",
		"Katagan",
		"Kama",
		"Hasta",
		"Yari",
		"Voulge",
		"Lancea",
		"Vel",
		"Assegai",
		"Rungu",
		"Basilisk",
		"Lantaka",
		"Xanadu",
	],

	cyborg: [
		"Ace",
		"Ada",
		"Adira",
		"Aiko",
		"Alexa",
		"Alia",
		"Alita",
		"Alma",
		"Amber",
		"Angel",
		"Anika",
		"Anna",
		"Anya",
		"Aphrodite",
		"Aria",
		"Ariel",
		"Ash",
		"Astra",
		"Athena",
		"Aura",
		"Ava",
		"Avery",
		"Bailey",
		"Bella",
		"Blade",
		"Blair",
		"Blaze",
		"Blitz",
		"Bolt",
		"Byte",
		"Cali",
		"Callie",
		"Camila",
		"Cara",
		"Carmen",
		"Cassidy",
		"Catherine",
		"Celeste",
		"Cherry",
		"Chloe",
		"Chronos",
		"Cipher",
		"Claire",
		"Clara",
		"Cleo",
		"Cora",
		"Cortex",
		"Cyberia",
		"Cyra",
		"Daisy",
		"Dana",
		"Daniela",
		"Daphne",
		"Data",
		"Delta",
		"Demon",
		"Diva",
		"Dixie",
		"Dora",
		"Dot",
		"Echo",
		"Eden",
		"Electra",
		"Elena",
		"Eliana",
		"Elise",
		"Ella",
		"Ellie",
		"Elsa",
		"Ember",
		"Emma",
		"Enigma",
		"Eris",
		"Eva",
		"Eve",
		"Evie",
		"Faith",
		"Faye",
		"Fiona",
		"Flame",
		"Flash",
		"Flora",
		"Freya",
		"Frost",
		"Fury",
		"Galatea",
		"Galaxina",
		"Gia",
		"Gigi",
		"Gina",
		"Glitch",
		"Grace",
		"Hailey",
		"Halo",
		"Hana",
		"Harley",
		"Harper",
		"Hazel",
		"Heidi",
		"Hera",
		"Holly",
		"Hope",
		"Iris",
		"Isla",
		"Ivy",
		"Jade",
		"Jasmine",
		"Jenna",
		"Jessa",
		"Jessie",
		"Jill",
		"Jinx",
		"Joan",
		"Jodie",
		"Jordan",
		"Joy",
		"Juno",
		"Kara",
		"Karma",
		"Kate",
		"Kayla",
		"Kaylee",
		"Keira",
		"Kelly",
		"Kendra",
		"Kira",
		"Kitty",
		"Kora",
		"Kyla",
		"Kylie",
		"Lana",
		"Lara",
		"Layla",
		"Leah",

		"Leila",
		"Lena",
		"Lexi",
		"Lia",
		"Lila",
		"Lily",
		"Lina",
		"Lisa",
		"Liv",
		"Lola",
		"Lorelei",
		"Lottie",
		"Lucia",
		"Lucy",
		"Luna",
		"Lydia",
		"Lyra",
		"Mabel",
		"Macy",
		"Maddie",
		"Maeve",
		"Maggie",
		"Maia",
		"Mara",
		"Maria",
		"Marie",
		"Marina",
		"Marta",
		"Maya",
		"Mia",
		"Mila",
		"Mina",
		"Mira",
		"Misty",
		"Molly",
		"Morgan",
		"Mya",
		"Nadia",
		"Nala",
		"Natalie",
		"Naya",
		"Nebula",
		"Nia",
		"Nico",
		"Nina",
		"Noa",
		"Noelle",
		"Nora",
		"Nova",
		"Nyx",
		"Olive",
		"Olivia",
		"Opal",
		"Orla",
		"Paige",
		"Paisley",
		"Parker",
		"Pearl",
		"Penny",
		"Peyton",
		"Phoebe",
		"Piper",
		"Pixel",
		"Poppy",
		"Quinn",
		"Rain",
		"Raven",
		"Rebel",
		"Reese",
		"Remy",
		"Renee",
		"Ria",
		"Riley",
		"Rina",
		"Rita",
		"River",
		"Robin",
		"Rogue",
		"Romy",
		"Rosa",
		"Rose",
		"Rosie",
		"Roxy",
		"Ruby",
		"Rue",
		"Ryder",
		"Sabrina",
		"Sage",
		"Sally",
		"Sam",
		"Sara",
		"Sasha",
		"Scarlet",
		"Selena",
		"Serena",
		"Serenity",
		"Shade",
		"Shadow",
		"Shay",
		"Shea",
		"Shelby",
		"Sienna",
		"Sierra",
		"Silver",
		"Sky",
		"Skye",
		"Skylar",
		"Sofia",
		"Sophia",
		"Sophie",
		"Spark",
		"Spectre",
		"Stella",
		"Storm",
		"Summer",
		"Sydney",
		"Talia",
		"Tara",
		"Tasha",
		"Tatum",
		"Taylor",
		"Tessa",
		"Thalia",
		"Thea",
		"Tia",
		"Tina",
		"Tori",
		"Trinity",
		"Tris",
		"Tyra",
		"Valerie",
		"Valkyrie",
		"Vega",
		"Vera",
		"Veronica",
		"Vesper",
		"Violet",
		"Vixen",
		"Willa",
		"Winter",
		"Wren",
		"Xena",
		"Zara",
		"Zara",
		"Zia",
		"Zoe",
		"Zoey",
		"Zola",
		"Zora",
		"Zoya",
		"Zyra"
	],
	bast: [
		"Ahhotep",
		"Ahmose",
		"Akila",
		"Amunet",
		"Anat",
		"Anippe",
		"Ankhesenamun",
		"Ankhet",
		"Asenath",
		"Auset",
		"Bastet",
		"Berenice",
		"Cleopatra",
		"Djoser",
		"Esi",
		"Eshe",
		"Hatshepsut",
		"Heba",
		"Heqet",
		"Hetepheres",
		"Iman",
		"Imhotep",
		"Isis",
		"Jendayi",
		"Kamilah",
		"Keket",
		"Kiya",
		"Layla",
		"Maat",
		"Mandisa",
		"Mara",
		"Mehit",
		"Menna",
		"Meret",
		"Meritamen",
		"Meryt",
		"Mesi",
		"Mut",
		"Nadia",
		"Nafretiri",
		"Nailah",
		"Nakia",
		"Nebet",
		"Nebetah",
		"Nefertari",
		"Nefertiti",
		"Neith",
		"Nekhbet",
		"Nema",
		"Nenet",
		"Nephthys",
		"Nerfertum",
		"Nesma",
		"Nila",
		"Nitocris",
		"Nour",
		"Nubia",
		"Nyla",
		"Panya",
		"Rana",
		"Rania",
		"Rashida",
		"Ren",
		"Renenutet",
		"Safiya",
		"Salma",
		"Sanaa",
		"Saniya",
		"Sekhmet",
		"Selma",
		"Serqet",
		"Shani",
		"Sharmila",
		"Shayma",
		"Sobek",
		"Sohalia",
		"Sopdet",
		"Tahirah",
		"Talibah",
		"Tanis",
		"Taweret",
		"Tefnut",
		"Thema",
		"Thutmose",
		"Tiye",
		"Umayma",
		"Wadjet",
		"Yamila",
		"Yasmin",
		"Zahra",
		"Zalika",
		"Zara",
		"Zaynab",
		"Zillah",
		"Zola",
		"Zuberi"
	],
	DragonGirl: [
		"Aeliana", "Althaea", "Amaranya", "Amara", "Anais",
		"Angelina", "Astridra", "Aureliax", "Azuraitha", "Brynhildr",
		"Caelia", "Camilla", "Chiaraflame",
		"Draconia", "Drakaina", "Elysia", "Emmeline",
		"Fenra", "Fiora", "Galladria", "Gwyndolin",
		"Helios", "Ilyana", "Ignisia", "Isolde", "Jasmina",
		"Kaida", "Kaelith", "Lysandra", "Lorelei", "Luciana",
		"Myrrh", "Maelis", "Nimue", "Norberta", "Ophira",
		"Pyralis", "Pandora", "Quelara", "Ravana", "Ramoth",
		"Siveth", "Sylvara", "Tiamara", "Ursula", "Vaeloria",
		"Vermithrax", "Wyverna", "Xanthe", "Ysolt", "Zephyra",
		"Belladonna", "Dahlia",
		"Umbra", "Vespera", "Wisteria", "Xylia", "Ygraine",
		"Zephyrine", "Zara", "Zephyr",
	],

};